import happyEmojiImage from "../../images/emoji-happy.png";
import mehEmojiImage from "../../images/emoji-meh.png";
import angryEmojiImage from "../../images/emoji-angry.png";
import serverImage from "../../images/server-2.png";
import databaseImage from "../../images/database.png";
import loadBalancerImage from "../../images/load-balancer.png";
import cdnImage from "../../images/cdn.png";
import asgImage from "../../images/auto-scaling-group.png";
import readReplicaImage from "../../images/database-read-replica.png";
import cacheImage from "../../images/redis-cache.svg";
import { BlockTypes } from "../../models/block-types";
import lambdaImage from "../../images/lambda.png";
import queueImage from "../../images/queue-icon.png";
import nlbImage from "../../images/network-load-balancer.png";

const getAltText = (blockType: BlockTypes) => {
  switch (blockType) {
    case BlockTypes.USER:
      return "user";
    case BlockTypes.APP_SERVER:
      return "app server";
    case BlockTypes.DATABASE:
      return "database";
    case BlockTypes.LOAD_BALANCER:
      return "load balancer";
    case BlockTypes.CDN:
      return "CDN";
    case BlockTypes.AUTO_SCALING_GROUP:
      return "Auto Scaling Group";
    case BlockTypes.LAMBDA:
      return "lambda";
    case BlockTypes.CACHE:
      return "cache";
    case BlockTypes.DB_READ_REPLICA:
      return "read replica";
    case BlockTypes.QUEUE:
      return "queue";
    case BlockTypes.NETWORK_LOAD_BALANCER:
      return "network load balancer";
    default:
      return "";
  }
}

const getImage = (blockType: BlockTypes, percentageSuccess?: number) => {
  switch (blockType) {
    case BlockTypes.USER:
      return getUserImage(percentageSuccess);
    case BlockTypes.APP_SERVER:
      return serverImage;
    case BlockTypes.DATABASE:
      return databaseImage;
    case BlockTypes.LOAD_BALANCER:
      return loadBalancerImage;
    case BlockTypes.CDN:
      return cdnImage;
    case BlockTypes.AUTO_SCALING_GROUP:
      return asgImage;
    case BlockTypes.LAMBDA:
      return lambdaImage;
    case BlockTypes.CACHE:
      return cacheImage;
    case BlockTypes.DB_READ_REPLICA:
      return readReplicaImage;
    case BlockTypes.QUEUE:
      return queueImage;
    case BlockTypes.NETWORK_LOAD_BALANCER:
      return nlbImage;
    default:
      return "";
  }
}

const getUserImage = (percentageSuccess?: number) => {
  let userImage = happyEmojiImage;
  if (percentageSuccess !== undefined) {
    if (percentageSuccess < 75) {
      userImage = angryEmojiImage;
    } else if (percentageSuccess < 90) {
      userImage = mehEmojiImage;
    }
  }

  return userImage;
}

interface Props {
  blockType: BlockTypes;
  width: number;
  height: number;
  percentageSuccess?: number;
}

export const BlockImage: React.FC<Props> = ({
  blockType,
  width,
  height,
  percentageSuccess,
}) => {
  return (
    <img src={getImage(blockType, percentageSuccess)} width={width} height={height} alt={getAltText(blockType)} />
  );
};
